function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSoftwareDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    width: 406,
    height: 306,
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5F1FF"
    },
    cx: 366.121,
    cy: 170.069,
    r: 85.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -205.715 205.3315)",
    style: {
      fill: "#E5F1FF"
    },
    cx: 144.999,
    cy: 350.986,
    rx: 50.16,
    ry: 50.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9CCEA"
    },
    d: "M144.33,112.859c-25.326,0-45.856,20.531-45.856,45.857c0,25.326,20.531,45.857,45.856,45.857 c25.326,0,45.857-20.531,45.857-45.857C190.186,133.39,169.655,112.859,144.33,112.859z M144.33,188.034 c-16.192,0-29.318-13.126-29.318-29.318s13.126-29.318,29.318-29.318c16.192,0,29.318,13.126,29.318,29.318 S160.521,188.034,144.33,188.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F3157"
    },
    d: "M317.577,406.04c0,2.906-2.356,5.262-5.262,5.262H179.256c-2.906,0-5.262-2.356-5.262-5.262 c0-2.906,2.356-5.262,5.262-5.262h47.235l6.515-12.028h11.276h3.007h11.276l6.515,12.028h47.235 C315.221,400.778,317.577,403.134,317.577,406.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.787,
    y: 377.85,
    style: {
      fill: "#FF4D6B"
    },
    width: 21.801,
    height: 6.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.787,
    y: 367.325,
    style: {
      fill: "#FF4D6B"
    },
    width: 21.801,
    height: 6.39
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF4D6B",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "0,5.6381"
    },
    d: " M418.264,345.701c-3.792,1.456-7.91,2.253-12.214,2.253c-18.828,0-34.092-15.263-34.092-34.092s15.263-34.092,34.092-34.092 c18.828,0,34.091,15.263,34.091,34.092c0,5.045-1.096,9.834-3.062,14.142"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c6595"
    },
    d: "M322.004,153.811h-5.443c-1.13-4.836-3.032-9.373-5.579-13.472l3.848-3.848 c1.659-1.659,1.659-4.349,0-6.008l-8.55-8.55c-1.659-1.659-4.349-1.659-6.008,0l-3.848,3.847 c-4.098-2.547-8.635-4.449-13.471-5.578v-5.443c0-2.346-1.902-4.248-4.248-4.248h-12.091c-2.346,0-4.248,1.902-4.248,4.248v5.443 c-4.836,1.129-9.373,3.032-13.472,5.578l-3.848-3.847c-1.659-1.659-4.349-1.659-6.008,0l-8.549,8.55 c-1.659,1.659-1.659,4.349,0,6.008l3.848,3.848c-2.547,4.098-4.449,8.635-5.579,13.472h-5.443c-2.346,0-4.248,1.902-4.248,4.248 v12.091c0,2.346,1.902,4.248,4.248,4.248h5.443c1.129,4.836,3.032,9.373,5.578,13.472l-3.847,3.848 c-1.659,1.659-1.659,4.349,0,6.008l8.549,8.55c1.659,1.659,4.349,1.659,6.008,0l3.848-3.847 c4.098,2.547,8.635,4.449,13.472,5.579v5.443c0,2.346,1.902,4.248,4.248,4.248h12.091c2.346,0,4.248-1.902,4.248-4.248v-5.443 c4.836-1.13,9.373-3.032,13.472-5.579l3.848,3.847c1.659,1.659,4.349,1.659,6.008,0l8.55-8.55c1.659-1.659,1.659-4.349,0-6.008 l-3.848-3.848c2.547-4.098,4.449-8.635,5.579-13.472h5.443c2.346,0,4.248-1.902,4.248-4.248v-12.091 C326.252,155.712,324.35,153.811,322.004,153.811z M272.66,185.672c-11.911,0-21.567-9.656-21.567-21.568 c0-11.911,9.656-21.567,21.567-21.567c11.911,0,21.568,9.656,21.568,21.567C294.228,176.016,284.572,185.672,272.66,185.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F3775"
    },
    d: "M96.011,364.453c-6.333,0-11.467-5.134-11.467-11.468V173.522c0-6.334,5.134-11.468,11.468-11.468 h299.548c6.333,0,11.468,5.134,11.468,11.467v179.463c0,6.333-5.134,11.468-11.468,11.468H96.011z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.058,
    y: 187.094,
    style: {
      fill: "#284D89"
    },
    width: 33.265,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.088,
    y: 187.094,
    style: {
      fill: "#284D89"
    },
    width: 33.265,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.574,
    y: 187.094,
    style: {
      fill: "#284D89"
    },
    width: 33.265,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.06,
    y: 187.094,
    style: {
      fill: "#284D89"
    },
    width: 33.265,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.863,
    y: 187.094,
    style: {
      fill: "#FF4D6B"
    },
    width: 59.482,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.785,
    y: 187.094,
    style: {
      fill: "#2889DB"
    },
    width: 59.482,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.246,
    y: 181.268,
    style: {
      fill: "#2889DB"
    },
    width: 5.826,
    height: 3.571
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.246,
    y: 200.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 60.797,
    height: 3.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.246,
    y: 206.734,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.042,
    height: 3.571
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284D89"
    },
    d: "M172.614,338.759h-56.381c-4.204,0-7.611-3.408-7.611-7.611v-102.05 c0-4.204,3.408-7.611,7.611-7.611h56.381c4.204,0,7.611,3.408,7.611,7.611v102.05 C180.225,335.351,176.818,338.759,172.614,338.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 238.683,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.962,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 246.858,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.962,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 255.033,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.962,
    height: 3.665
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 289.144,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.659,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 297.319,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.659,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.826,
    y: 297.319,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.659,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 279.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.209,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.109,
    y: 279.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.886,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.046,
    y: 279.841,
    style: {
      fill: "#FF4D6B"
    },
    width: 25.184,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 266.028,
    style: {
      fill: "#2889DB"
    },
    width: 3.524,
    height: 3.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 272.511,
    style: {
      fill: "#FF4D6B"
    },
    width: 3.524,
    height: 3.665
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "137.188,301.736 135.872,301.736 139.02,297.037 140.336,297.037  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 308.031,
    style: {
      fill: "#282E5C"
    },
    width: 54.408,
    height: 3.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.643,
    y: 315.079,
    style: {
      fill: "#282E5C"
    },
    width: 54.408,
    height: 3.101
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c6595"
    },
    d: "M433.752,269.974H284.154c-3.737,0-6.766-3.029-6.766-6.766v-40.594 c0-3.737,3.029-6.766,6.766-6.766h149.598c3.737,0,6.766,3.029,6.766,6.766v40.594 C440.517,266.945,437.488,269.974,433.752,269.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    d: "M325.876,250.805 c0,0,8.269-20.297,31.949-15.411c23.68,4.886,35.708,31.573,66.154,9.773"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.171,
    y: 251.932,
    style: {
      fill: "#1c6595",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 3.383,
    height: 3.383
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#1c6595",
      stroke: "#FFFFFF",
      strokeWidth: 0.5638,
      strokeMiterlimit: 10
    },
    x1: 330.011,
    y1: 234.454,
    x2: 372.86,
    y2: 234.454
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#1c6595",
      stroke: "#FFFFFF",
      strokeWidth: 0.5638,
      strokeMiterlimit: 10
    },
    x1: 379.438,
    y1: 254.564,
    x2: 422.288,
    y2: 254.564
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.053,
    y: 232.763,
    style: {
      fill: "#1c6595",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 3.383,
    height: 3.383
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284D89"
    },
    d: "M305.955,283.882H273.63c-2.699,0-4.886-2.188-4.886-4.886v-48.488 c0-2.699,2.188-4.886,4.886-4.886h32.325c2.699,0,4.886,2.188,4.886,4.886v48.488 C310.841,281.694,308.654,283.882,305.955,283.882z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 233.891,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.962,
    height: 3.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 241.26,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.962,
    height: 3.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 248.63,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.021,
    height: 3.304
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 256.254,
    style: {
      fill: "#1c6595"
    },
    width: 15.599,
    height: 3.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 263.624,
    style: {
      fill: "#1c6595"
    },
    width: 10.524,
    height: 3.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.321,
    y: 270.993,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.524,
    height: 3.304
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#284D89",
      strokeWidth: 2.2552,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 414.206,
    y1: 208.519,
    x2: 431.121,
    y2: 208.519
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF5C66",
      strokeWidth: 1.0152,
      strokeMiterlimit: 10
    },
    d: "M376.202,303.958l-5.838,4.569 l-8.376,1.523c0,0-7.868-0.508-8.63-0.508c-0.761,0-6.091-4.315-6.091-4.315l-9.899-3.553l-6.853,2.538l-8.122-1.777 l-12.183-0.762l-11.675,4.569l-9.645,1.523l-8.63,2.792l-9.645,0.762l-10.406-8.122l-9.645-1.777l-9.899,5.584l-7.868,2.538 l-8.933-0.254l-11.258,6.853h-6.713l-11.337,3.976"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F7F7F7",
      strokeWidth: 0.2538,
      strokeMiterlimit: 10
    },
    x1: 194.726,
    y1: 320.287,
    x2: 376.455,
    y2: 320.287
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.95,
    y: 318.002,
    style: {
      fill: "#F7F7F7"
    },
    width: 1.861,
    height: 4.569
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.356,
    y: 318.002,
    style: {
      fill: "#F7F7F7"
    },
    width: 1.861,
    height: 4.569
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F7F7F7",
      strokeWidth: 0.5076,
      strokeMiterlimit: 10
    },
    d: "M194.726,320.287"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F7F7F7",
      strokeWidth: 0.2538,
      strokeMiterlimit: 10
    },
    x1: 376.286,
    y1: 320.287,
    x2: 376.286,
    y2: 304.973
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F7"
    },
    d: "M377.301,304.212c0,0.794-0.644,1.438-1.438,1.438s-1.438-0.644-1.438-1.438 c0-0.794,0.644-1.438,1.438-1.438S377.301,303.418,377.301,304.212z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 194.9795 331.0042)",
    style: {
      fill: "#F7F7F7",
      fontFamily: "'BebasNeueRegular'",
      fontSize: "8.122px"
    }
  }, "beta test"), /*#__PURE__*/React.createElement("rect", {
    x: 236.69,
    y: 326.886,
    style: {
      fill: "#28385E"
    },
    width: 113.031,
    height: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.69,
    y: 326.886,
    style: {
      fill: "#FF4D6B"
    },
    width: 69.375,
    height: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.69,
    y: 330.777,
    style: {
      fill: "#28385E"
    },
    width: 55.585,
    height: 2.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4D6B"
    },
    points: "201.452,336.827 208.305,336.827 209.194,334.923 195.361,334.923 195.361,338.096  200.183,338.096  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.894,
    y: 334.902,
    style: {
      fill: "#F7F7F7"
    },
    width: 0.762,
    height: 0.761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.621,
    y: 334.902,
    style: {
      fill: "#F7F7F7"
    },
    width: 0.761,
    height: 0.761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.348,
    y: 334.902,
    style: {
      fill: "#F7F7F7"
    },
    width: 0.762,
    height: 0.761
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 367.4004 299.137)",
    style: {
      fill: "#F7F7F7",
      fontFamily: "'BebasNeueBook'",
      fontSize: "8.122px"
    }
  }, "500"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28385E"
    },
    points: "357.843,332.977 356.15,332.977 353.443,326.886 355.135,326.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28385E"
    },
    points: "362.242,332.977 360.55,332.977 357.843,326.886 359.535,326.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28385E"
    },
    points: "366.641,332.977 364.949,332.977 362.242,326.886 363.934,326.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28385E"
    },
    points: "371.041,332.977 369.349,332.977 366.641,326.886 368.333,326.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28385E"
    },
    points: "375.356,332.977 373.663,332.977 370.956,326.886 372.648,326.886  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340.497,
    y: 123.252,
    style: {
      fill: "#A9CCEA"
    },
    width: 27.513,
    height: 4.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.497,
    y: 132.07,
    style: {
      fill: "#A9CCEA"
    },
    width: 41.484,
    height: 4.927
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.497,
    y: 140.888,
    style: {
      fill: "#A9CCEA"
    },
    width: 51.157,
    height: 4.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.497,
    y: 149.706,
    style: {
      fill: "#A9CCEA"
    },
    width: 19.56,
    height: 4.928
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.827,
    y: 182.64,
    style: {
      fill: "#2889DB"
    },
    width: 27.513,
    height: 4.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.827,
    y: 191.458,
    style: {
      fill: "#A9CCEA"
    },
    width: 41.484,
    height: 4.927
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.827,
    y: 200.275,
    style: {
      fill: "#A9CCEA"
    },
    width: 51.157,
    height: 4.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.827,
    y: 209.094,
    style: {
      fill: "#A9CCEA"
    },
    width: 19.56,
    height: 4.928
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 120.462,
    y: 355.673,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 117.272,
    height: 15.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.03,
    y: 235.77,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 5.638,
    height: 34.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1592 0.1592 0.9872 -44.7931 68.6549)",
    style: {
      fill: "#FF4D6B"
    },
    cx: 406.05,
    cy: 313.863,
    rx: 19.432,
    ry: 19.433
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M404.642,312.04l-7.718,2.828l7.718,2.805v2.898l-11.033-4.196v-3.013l11.033-4.195V312.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M407.163,309.166l11.033,4.195v3.013l-11.033,4.196v-2.898l7.718-2.805l-7.718-2.828V309.166z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF4D6B",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    d: "M438.45,329.738 c0,1.401-1.136,2.537-2.537,2.537c-1.401,0-2.537-1.136-2.537-2.537c0-1.401,1.136-2.537,2.537-2.537 C437.314,327.201,438.45,328.337,438.45,329.738z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.26,
    y: 145.936,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 91.901,
    height: 9.585
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.206,
    y: 149.037,
    style: {
      fill: "#1c6595"
    },
    width: 56.945,
    height: 2.819
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 220.735,
    style: {
      fill: "#284D89"
    },
    width: 67.281,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 220.735,
    style: {
      fill: "#2889DB"
    },
    width: 30.493,
    height: 3.383
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 229.474,
    style: {
      fill: "#284D89"
    },
    width: 67.281,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 229.474,
    style: {
      fill: "#FF4D6B"
    },
    width: 46.843,
    height: 3.383
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 238.213,
    style: {
      fill: "#284D89"
    },
    width: 67.281,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.441,
    y: 238.213,
    style: {
      fill: "##1c6595"
    },
    width: 13.719,
    height: 3.383
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.723,
    y: 214.815,
    style: {
      fill: "#284D89"
    },
    width: 1.316,
    height: 1.316
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.234,
    y: 214.815,
    style: {
      fill: "#284D89"
    },
    width: 1.316,
    height: 1.316
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.744,
    y: 214.815,
    style: {
      fill: "#284D89"
    },
    width: 1.316,
    height: 1.316
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.92,
    y: 260.891,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.192,
    height: 2.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.438,
    y: 260.891,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.193,
    height: 2.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.955,
    y: 260.891,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.193,
    height: 2.193
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.568,
    y: 173.763,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.663,
    y: 173.763,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.758,
    y: 173.763,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 291.308,
    y: 343.657,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.403,
    y: 343.657,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.498,
    y: 343.657,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.111,
    height: 4.111
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.833,
    y: 229.818,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.192,
    height: 2.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.35,
    y: 229.818,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.193,
    height: 2.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.868,
    y: 229.818,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.193,
    height: 2.193
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 389.775,
    y: 227.125,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.46,
    height: 3.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.775,
    y: 233.421,
    style: {
      fill: "#287DD1"
    },
    width: 10.82,
    height: 3.571
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "##1c6595"
    },
    points: "95.654,234.454 87.761,234.454 87.761,226.561 80.431,226.561 80.431,234.454  72.538,234.454 72.538,241.784 80.431,241.784 80.431,249.677 87.761,249.677 87.761,241.784 95.654,241.784  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2889DB"
    },
    points: "74.532,256.443 69.719,256.443 69.719,251.63 65.25,251.63 65.25,256.443 60.436,256.443  60.436,260.912 65.25,260.912 65.25,265.725 69.719,265.725 69.719,260.912 74.532,260.912  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284D89"
    },
    d: "M206.267,252.24c-6.817,0-12.344,5.527-12.344,12.344c0,6.818,5.527,12.344,12.344,12.344 c6.818,0,12.344-5.527,12.344-12.344C218.611,257.767,213.084,252.24,206.267,252.24z M206.267,271.017 c-3.553,0-6.432-2.88-6.432-6.433s2.88-6.433,6.432-6.433c3.553,0,6.433,2.88,6.433,6.433S209.819,271.017,206.267,271.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c6595"
    },
    d: "M197.864,263.367c1.147,0,2.152-0.682,2.674-1.704c1.063-2.084,3.229-3.512,5.729-3.512 c2.501,0,4.666,1.428,5.73,3.512c0.521,1.022,1.527,1.704,2.674,1.704l0,0c2.16,0,3.638-2.263,2.688-4.204 c-2.007-4.1-6.219-6.923-11.091-6.923c-4.872,0-9.084,2.823-11.091,6.924C194.226,261.104,195.703,263.367,197.864,263.367 L197.864,263.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284D89"
    },
    d: "M226.999,264.584c0,6.817,5.527,12.344,12.344,12.344c6.818,0,12.344-5.527,12.344-12.344 c0-6.818-5.527-12.344-12.344-12.344C232.526,252.24,226.999,257.767,226.999,264.584z M245.776,264.584 c0,3.552-2.88,6.432-6.433,6.432c-3.553,0-6.433-2.88-6.433-6.432c0-3.553,2.88-6.433,6.433-6.433 C242.896,258.151,245.776,261.031,245.776,264.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D6B"
    },
    d: "M238.127,272.987c0-1.147-0.682-2.152-1.704-2.674c-2.084-1.063-3.512-3.229-3.512-5.729 c0-2.501,1.428-4.666,3.512-5.73c1.022-0.521,1.704-1.527,1.704-2.674l0,0c0-2.16-2.263-3.638-4.204-2.688 c-4.1,2.007-6.924,6.219-6.924,11.092c0,4.872,2.824,9.084,6.924,11.091C235.863,276.625,238.127,275.148,238.127,272.987 L238.127,272.987z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.464,
    y: 215.849,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 22.552,
    height: 54.126
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 226.279,
    style: {
      fill: "##1c6595"
    },
    width: 6.578,
    height: 1.944
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 230.616,
    style: {
      fill: "##1c6595"
    },
    width: 6.578,
    height: 1.944
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 234.953,
    style: {
      fill: "##1c6595"
    },
    width: 6.578,
    height: 1.944
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 257.506,
    style: {
      fill: "##1c6595"
    },
    width: 6.578,
    height: 1.944
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 241.314,
    style: {
      fill: "##1c6595"
    },
    width: 9.585,
    height: 1.944
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 245.651,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.585,
    height: 1.944
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.659,
    y: 249.988,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.585,
    height: 1.944
  })), /*#__PURE__*/React.createElement("rect", {
    x: 67.651,
    y: 283.506,
    style: {
      fill: "#1c6595"
    },
    width: 28.566,
    height: 28.566
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.617,
    y: 290.271,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 28.566,
    height: 28.566
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.441,
    y: 366.198,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 12.028,
    height: 12.028
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    points: "263.105,347.216  273.254,347.216 278.892,352.854 337.528,352.854 346.549,343.833 378.123,343.833  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    cx: 260.145,
    cy: 347.357,
    r: 2.96
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    cx: 381.176,
    cy: 343.692,
    r: 2.96
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c6595"
    },
    d: "M420.972,188.034c0,2.076-1.683,3.759-3.759,3.759s-3.759-1.683-3.759-3.759 s1.683-3.759,3.759-3.759S420.972,185.958,420.972,188.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D6B"
    },
    d: "M73.665,334.625c0,2.076-1.683,3.759-3.759,3.759c-2.076,0-3.759-1.683-3.759-3.759 c0-2.076,1.683-3.759,3.759-3.759C71.983,330.866,73.665,332.549,73.665,334.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D6B"
    },
    d: "M90.956,348.532c0,3.633-2.945,6.578-6.578,6.578s-6.578-2.945-6.578-6.578 s2.945-6.578,6.578-6.578S90.956,344.899,90.956,348.532z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.665,
    y: 370.708,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 26.311,
    height: 6.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.665,
    y: 381.984,
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeMiterlimit: 10
    },
    width: 57.696,
    height: 6.014
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.481,
    y1: 376.468,
    x2: 121.104,
    y2: 382.845
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 133.612,
    y1: 376.468,
    x2: 127.235,
    y2: 382.845
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 139.744,
    y1: 376.468,
    x2: 133.367,
    y2: 382.845
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 145.875,
    y1: 376.468,
    x2: 139.498,
    y2: 382.845
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1c6595",
      strokeWidth: 1.1276,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 152.007,
    y1: 376.468,
    x2: 145.63,
    y2: 382.845
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/custom_software_development.c7a333ac5b109e6a7cb3058f6fbb5767.svg";
export { ForwardRef as ReactComponent };